import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap'

import Footer from './Footer'
import HeaderTop from './HeaderTop'
import SideNavTop from './SideNavTop'
import ArticleCardOnly from './ArticleCardOnly'

import '../Accueil.css'

// Firebase
import base from '../base'

class ArticleOnly extends Component {

    state = {
        name: this.props.match.params.nomArticle,
        recette: "",
        recetteOnly: [],
        redirect:false
        }
    
    componentDidMount(){
      if(this.props.location.state !== undefined)
      {
        this.setState({
          recette: this.props.location.state.recette,
        })
        //reference ds firebase    
        this.ref = base.syncState(`/listeRecettes/${this.props.location.state.recette}`,{
          context: this,
          state: 'recetteOnly'
        })
      }else{
        //reference ds firebase    
        this.ref = base.syncState(`/listeRecettes`,{
          context: this,
          state: 'recetteOnly'
        })
      }
    }

    handleCHange = event => {
      const { name, value } = event.target
      this.setState({ [name]: value })
  }
  
    handleSubmit = event => {
      //on gere le form
      event.preventDefault()
      this.props.history.push(`/recherche/${this.state.search}`);
  
    }

    setRedirect = () => {
      this.setState({
        redirect: true
      })
    }
      
    handleSubmitFacebbok = () => {
      if (this.state.redirect) {
          window.location.href = "https://www.facebook.com/clubCAPN/";
      }
    }
    
    componentWillUnmount () {
        //fermer la reference ds firebase
        //la connexion est terminée entre notre state et firebase
        base.removeBinding(this.ref)
        }
    
        setArticles = () => {
        this.setState({
            redirect: true
        })
        }

        render () {  
        return (
            <>
            <Container fluid>
            <Row>
            <SideNavTop/>
            <Col lg={10} md={12} sm={12} xs={12} id="page-content-wrapper" className="nopadding">
              <HeaderTop
                handleSubmit={this.handleSubmit}
                handleCHange={this.handleCHange}
                handleSubmitFacebbok={this.handleSubmitFacebbok}
                setRedirect={this.setRedirect}
              />
    
                      <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                      {((Object.keys(this.state.recetteOnly).length !== 0)) &&
                          <div className="actu-content-only">
                            <ArticleCardOnly  details={this.state.recetteOnly}/>
                          </div>
                      }
                      </Col>
    
    
                  <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                    <Footer />
                  </Col>
                </Col>
              </Row>
            </Container>
          </>
        )
    }
}
export default ArticleOnly;